import "../css/Footer.css";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  if (location.pathname === "/about") return null;

  return (
    <div className="footer_code">
      <div className="footer">
        <Link to="/">
          <img
            src="/img/logo-spats-footer.png"
            className="footer-logo"
            alt=""
          />
        </Link>
        <ul className="menu">
          <div>
            <li>
              <Link className="menu__link" to="/about">
                About
              </Link>
            </li>
            <li>
              <Link className="menu__link" to="/events">
                Events
              </Link>
            </li>
          </div>
          <div>
            <li>
              <Link className="menu__link" to="/team">
                Team
              </Link>
            </li>
            <li>
              <Link className="menu__link" to="/latest">
                Updates
              </Link>
            </li>
            <li>
              <Link className="menu__link" to="/blog">
                Blog
              </Link>
            </li>
            <li>
              <Link className="menu__link" to="/contact">
                Contact
              </Link>
            </li>
          </div>
        </ul>

        <ul className="social_icon">
          {[
            { link: "https://www.facebook.com/spAtsiitkgp/", icon: "fa-facebook" },
            { link: "https://www.instagram.com/spats.nssc.iitkgp/", icon: "fa-instagram" },
            { link: "https://www.linkedin.com/company/spats/", icon: "fa-linkedin" },
            { link: "https://www.youtube.com/@spAtsiitkgp", icon: "fa-youtube-play" },
            { link: "https://x.com/spats_iitkgp", icon: "fa-twitter" },
          ].map((social, i) => (
            <li className="social-icon__link" key={i}>
              <a
                className="social-icon__link"
                href={social.link}
                target="_blank"
                rel="noreferrer"
              >
                <i className={`fab ${social.icon}`} aria-hidden="true"></i>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="footer-copyright">
        {" "}
        &copy;Space Technology Students' Society{" "}
        <img
          src="https://cdn.pixabay.com/photo/2014/04/03/11/53/rocket-312455__340.png"
          width="40"
          className="rob"
          alt=""
        />
      </div>
    </div>
  );
}
